import  theme  from "@/styles/theme";
import { isBrowser } from "@/utils/general";

export const getBgColor = (bgColor?: string) => {
  return bgColor
    ? bgColor?.startsWith("linear") || bgColor?.startsWith("gradient")
      ? `background-image:${theme.background.gradientRed}`
      : `background:${bgColor}`
    : theme.background.default;
};

export const getLineHeight = (size?:number, isMobile?:boolean):number => {
  const sizeForUse = size ? size : 16;
  const divide = isMobile ? 16 : 12;
  return sizeForUse / divide;
}


export const getFontSize = (size?: number) => {
  const sizeForUse = size ? size : 16;
  const sizeForRem = sizeForUse / 16;
  return `font-size: ${clampBuilder(320, 1280, sizeForRem -0.3, sizeForRem)};
  line-height: ${getLineHeight(size)}rem;`;
};

export function clampBuilder( minWidthPx:number, maxWidthPx:number, minFontSize:number, maxFontSize:number ) {
  const root = isBrowser() ? document?.querySelector( "html" ) : null;
  const pixelsPerRem = root ? Number( getComputedStyle( root as Element ).fontSize.slice( 0,-2 )) : 16;

  const minWidth = minWidthPx / pixelsPerRem;
  const maxWidth = maxWidthPx / pixelsPerRem;

  const slope = ( maxFontSize - minFontSize ) / ( maxWidth - minWidth );
  const yAxisIntersection = -minWidth * slope + minFontSize

  return `clamp( ${ minFontSize }rem, ${ yAxisIntersection }rem + ${ slope * 100 }vw, ${ maxFontSize }rem )`;
}